import { map } from 'rxjs/operators';
import { Injector, Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ChangeIncorrectPaymentPayerFormComponent } from '../../component/change-incorrect-payment-payer-form/change-incorrect-payment-payer-form.component';
import { IncorrectPayment } from '../../model/incorrect-payment';
import { IncorrectPaymentCommand } from '../../command/incorrect-payment';
import { Observable } from 'rxjs';

@Injectable()
export class ChangePayerCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindow: ActionWindowService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === IncorrectPaymentCommand.changePayer && command.context instanceof IncorrectPayment;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionWindow.open(ChangeIncorrectPaymentPayerFormComponent, this._injector, null, command.context).pipe(
        map(result => {
          if (result) {
            (<IncorrectPayment>command.context).payerName = result.payerName;
          }
        })
      );
    }
  }
}
